import * as React from 'react';
import { PaymentMethodsContainer } from '../PaymentMethods';
import { DepositAmountContainer } from '../DepositAmount';
import { PaymentAmountContainer } from '../PaymentAmount';
import { CheckoutContainer } from '../Checkout';
import { ActionButtonsContainer } from '../ActionButtons';

export const Widget = () => {
  return (
    <>
      <DepositAmountContainer />
      <PaymentAmountContainer />

      <PaymentMethodsContainer />

      <CheckoutContainer />

      <ActionButtonsContainer />
    </>
  );
};
